import { render } from "./FloorPlanPageMainComponent.vue?vue&type=template&id=a0bf1e30"
import script from "./FloorPlanPageMainComponent.vue?vue&type=script&lang=js"
export * from "./FloorPlanPageMainComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Desktop/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__